<template>
    <div id="main">
        <div class="header_wrap">
            <div class="header_wrap__header">
                <div class="logo_wrap">
                    <!--<img src="../assets/images/Login/resource-platform-logo.png"/>-->
                    <div class="title">在线招生平台</div>
                </div>

                <div class="user_msg_wrap">
                    <div class="avatar_container">
                        <div class="avatar_wrapper clearfix"><div :style="{backgroundImage: `url(${userInfo.avatar})`}" class="user_avatar"></div>
                            <div class="name_container">
                                {{userInfo.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nav-bar" v-if="isKindergarten">
                <div class="nav-bar__welcome">欢迎您，<span>{{userInfo.name}}</span></div>
                <div class="nav-item-container">
                    <div class="nav-item" @click="jumpToPageKinder('/main/kindergarten/notice/noticeList')">
                        <div class="icon icon--nav-1"></div>
                        <div class="nav-item__text">招生公告</div>

                    </div>
                    <div class="nav-item" @click="jumpToPageKinder('/main/kindergarten/signup/signupList')">
                        <div class="icon icon--nav-2"></div>
                        <div class="nav-item__text">报名名单</div>
                    </div>
                    <div class="nav-item" @click="jumpToPageKinder('/main/kindergarten/setting/settingIndex')">
                        <div class="icon icon--nav-4"></div>
                        <div class="nav-item__text">系统设置</div>
                    </div>
                </div>
            </div>
            <div class="nav-bar" v-else>
                <div class="nav-bar__welcome">欢迎您，{{userInfo.name}}</div>
                <div class="nav-item-container">
                    <div class="nav-item" v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolNoticeManage') || checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuExamineManage')" @click="jumpToPage('/main/primary/notice/noticeList')">
                        <div class="icon icon--nav-1"></div>
                        <div class="nav-item__text">招生公告</div>
                    </div>
                    <div class="nav-item" v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolApplyStuManage')" @click="jumpToPage2">
                        <div class="icon icon--signup"></div>
                        <div class="nav-item__text">报名名单</div>
                    </div>
                    <div class="nav-item" v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuExamineManage')" @click="jumpToPage('/main/primary/review/')">
                        <div class="icon icon--review"></div>
                        <div class="nav-item__text">材料审核</div>
                    </div>
                    <div class="nav-item" v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolDataStaticManage')" @click="jumpToPage('/main/primary/accounting/dataAccounting/')">
                        <div class="icon icon--data"></div>
                        <div class="nav-item__text">数据统计</div>
                    </div>
                    <div class="nav-item" v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolSystemManage')" @click="jumpToPage('/main/primary/setting/signupSetting')">
                        <div class="icon icon--nav-4"></div>
                        <div class="nav-item__text">系统设置</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="module-container">
            <div class="module-container__inner">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js'
    import {mapGetters, mapMutations} from 'vuex';

    export default {
        name: "Main",
        mixins: [baseMixin],
        data() {
            return {
                isKindergarten: window.location.href.indexOf('kindergarten') !== -1
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'permission'])
        },
        methods: {
            ...mapMutations(['RESET_SCHOOLYEAR']),
            jumpToPage2(){
                this.$router.push({
                    path:'/main/primary/signup/signupList',
                    query:{state:0}
                })
            },
            jumpToPageKinder(path) {
                this.RESET_SCHOOLYEAR();
                this.jumpToPage(path);
            },
            logout() {
                this.$store.dispatch('LogOut').then(() => {
                    // location.reload();// 为了重新实例化vue-router对象 避免bug
                    this.$router.push('/login')
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/mixin";

    @include reset-global;

    .header_wrap__header {
        font-size: 0;
        @include clearfix;
        height: 50px;
        background: #324157;
        padding: 5px 0;
        min-width: 1320px;
        color: #fff;
        box-sizing: border-box;
    }

    .nav-bar {
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px #cdcdcd solid;
        position: fixed;
        top: 50px;
        height: 90px;
        padding: 5px 20px;
        width: 100%;
        z-index: 91;
        min-width: 1320px;
        font-family: AdobeHeitiStd-Regular;
    }

    .nav-bar__welcome {
        font-weight: 700;
        float: left;
        line-height: 70px;
        font-size: 25px;
        color: #676a6c;
        padding-left: 40px;
        span {
            color: #409EFF;
        }
    }
    .nav-item:hover {
        .nav-item__text {
            color: #4db3ff;
        }
    }
    .nav-item__text {
        font-weight: 700;
        display: block;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        color: #676a6c;
        font-family: MicrosoftYaHei;
    }
    .nav-item-container {
        float: right;
        height: 109px;
        box-sizing: border-box;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        & > * {
            @include middleIB;
            padding: 0 15px;
            position: relative;
            cursor: pointer;
            color: #444;
            line-height: normal;
        }


        .icon {
            @include wh(50px, 50px);
            @include cover-bg;
            margin: 0 auto;
            &--nav-1 {
                background-image: url(../assets/images/nav-icon1.png);
            }

            &--nav-2 {
                background-image: url(../assets/images/nav-icon2.png);
            }

            &--nav-3 {
                background-image: url(../assets/images/nav-icon3.png);
            }

            &--nav-4 {
                background-image: url(../assets/images/nav-icon4.png);
            }
            &--data {
                background-image: url(../assets/images/primary/icon-data.png);
            }
            &--signup {
                background-image: url(../assets/images/primary/icon-signup.png);
            }
            &--data {
                background-image: url(../assets/images/primary/icon-data.png);
            }
            &--review {
                background-image: url(../assets/images/primary/icon-review.png);
            }
        }
    }

    .header_wrap {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        min-width: 1200px;
        margin: 0;


        line-height: 40px;
        z-index: 1000;

        .logo_wrap {
            float: left;
            padding-left: 60px;
            max-width: 48%;

            img {
                float: left;
                width: 60px;
                height: 60px;
                margin: 3px 15px;
                border-radius: 4px;
            }

            .title {
                float: left;
                font-size: 20px;
            }
        }

        .nav_menu_wrap {
            float: left;

            .nav_item_container {

                li {
                    float: left;
                    height: 60px;
                    text-align: center;
                    font-size: 18px;
                    box-sizing: border-box;
                    border-bottom: 5px solid transparent;
                    transition: border-color .3s, background-color .3s, color .3s;

                    &:hover {
                        border-bottom: 5px solid #20a0ff;
                    }

                    .nav_item_link {
                        display: inline-block;
                        padding: 0 25px;
                        color: #fff;
                        text-decoration: none;
                    }
                }
            }
        }

        .user_msg_wrap {
            font-size: 0;
            float: right;
            position: relative;
            margin: 0 34px;

            .avatar_container {
                height: 100%;

                .avatar_wrapper {
                    height: 100%;
                    color: #fff;

                    .user_avatar {
                        float: left;
                        display: inline-block;
                        width: 40px;
                        height: 40px;
                        border: 2px #fff solid;
                        box-sizing: border-box;
                        vertical-align: middle;
                        border-radius: 50%;
                        @include cover-bg;
                    }

                    .name_container {
                        float: left;
                        display: inline-block;
                        font-size: 14px;
                        margin-right: 10px;
                        margin-left: 4px;
                        line-height: 40px;
                    }
                }
            }

            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 18px;
                font-size: 24px;
            }
        }

    }
    .module-container {
        position: absolute;
        top: 140px;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 25px 80px 30px 80px;
        min-width: 1320px;
        .module-container__inner {
            min-height: 100%;
            background-color: #fff;
            border-radius: 5px;
        }
    }
</style>
<style lang="scss">
    .router-link-active {
        color: #20a0ff !important;
    }

    .el-form-item__content .edui-default {
        line-height: 20px !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue